import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IdnConfigurationService } from 'src/app/core/services/common/idn-configuration.service';
import { PermissionsService } from 'src/app/core/services/common/permissions.service';
import { DialogService } from 'src/app/shared/dialog/confirm-dialog/dialog.service';
import { LogoutString } from 'src/app/shared/enum/logoutString';
import { fromEvent } from 'rxjs';
import { catchError, map, throttleTime } from 'rxjs/operators';
import { SharedComponent } from 'src/app/shared/enum/sharedComponentEnum';
import { InstanceService } from 'src/app/core/services/instance-management/instance.service';
import { MatIconRegistry } from '@angular/material/icon';
import { INSTANCE_OPERATIONS } from '../dashboard/layout/layout.component';
import { ExtensionService } from 'src/app/core/services/extension-management/extension.service';
import { SdkServiceService } from 'src/app/core/services/sdk-mangement/sdk-service.service';
import { LoaderService } from 'src/app/core/interceptors/loader/loader.service';
import { NotificationService } from 'src/app/shared/notification/notification.service';
import { AzureBlobStorageService } from 'src/app/core/services/azure-blob-storage/azure-blob-storage.service';
import { WorkbenchMgmtStaticString } from 'src/app/shared/enum/workbenchManagement';
import { ActivityNotificationService } from 'src/app/core/services/activity-notification/activity-notification.service';
@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {
  progress:number = 20;
  isPartnerDeveloper:boolean = false;
  isPartnerAdmin:boolean = false;
  isViewInstance:boolean =false;
  isViewExtension:boolean =false;
  partnerAccess:boolean =false;
  whatsNewMessage = "What's new in IDN!";
  public logoutEnum = LogoutString;
  public sharedEnum = SharedComponent;
  public WbMgmtEnum = WorkbenchMgmtStaticString;
  questions:any;
  isShow: boolean=false;
  isQuickActions:boolean = false;
  topPosToStartShowing = 0;
  setInterval = setInterval;
  approvalAccessToDebuggingUtilitiesProd:boolean=false;
  approvalAccessHangfire: boolean = false
  isApproveRejectInstance: boolean = false;
  isApproveRejectDeployment: boolean = false;
  isApproveRejectCertification: boolean = false;
  loggerInUserRole : any = ''
  url: string = "https://developer-help.icertis.com/idn-1-x-release-notes/";
  isDeveloper: boolean = false;
  _userName: any;
  isTechLead: boolean = false;
  isAdmin: boolean = false;
  Username(): string {
    this._userName =
      localStorage.getItem('username') != null
        ? localStorage.getItem('username')
        : '';
    return this._userName;
  }
  instightsCards: any = []
  quickLinksCards =[{id: "0",title: "Workbench",count: 1500, icon:"file_download", hasPermission: this.permissionService.getPermission('ViewSDK')},
      {id: "1",title: "Starter Kit",count: 700 ,icon:"file_download", hasPermission: this.permissionService.getPermission('CreateUser')},
      {id: "2",title: "Add User",count: 700 ,icon:"account_circle", hasPermission: this.permissionService.getPermission('CreateUser')},
      {id: "3",title: "Add Customer",count: 700 ,icon:"person_pin", hasPermission: this.permissionService.getPermission('CreateCustomer')},
      {id: "4",title: "Custom Solution",count: 700 ,icon:"file_upload", hasPermission: this.permissionService.getPermission('CreateSolutionPackage')},
      {id: "5",title: "Certification",count: 700 ,icon:"add_moderator", hasPermission: this.permissionService.getPermission('InitiateAutomaticCertification')},
      {id: "6",title: "Deployment",count:800, icon:"inventory_2", hasPermission: this.permissionService.getPermission('InitiateDeployment')},
      {id: "7",title: "Instance Tools",count:800, icon:"settings", hasPermission: this.permissionService.getPermission('AccessApplicationLogs')},
      {id: "8",title: "Provision ICI Users",count:800, icon:"manage_accounts", hasPermission: this.permissionService.getPermission('InstanceUserProvision')},
    ]
  links: any =[
    ]
  
  constructor(
    private titleService: Title,
    private dialogService: DialogService,
    private router: Router,
    private permissionService: PermissionsService,
    private idnConfiguration:IdnConfigurationService,
    private instanceService: InstanceService,
    private extensionservice: ExtensionService,
    iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private SdkServices: SdkServiceService,
    private loader: LoaderService,
    private notificationService: NotificationService,  
    private blobService: AzureBlobStorageService,
    private activityNotifService: ActivityNotificationService,  
  ) {
    iconRegistry.addSvgIconLiteral(
          'instance_operations',
          sanitizer.bypassSecurityTrustHtml(INSTANCE_OPERATIONS)
        );
   }
  

  ngOnInit(): void {
    this.approvalAccessToDebuggingUtilitiesProd = this.permissionService.getPermission('ApprovalAccessToDebuggingUtilities-Prod');
    this.approvalAccessHangfire = this.permissionService.getPermission('ApprovalAccessToHangfire');
    this.isApproveRejectInstance = this.permissionService.getPermission('ApproveInstance') || this.permissionService.getPermission('RejectInstance');
    this.isApproveRejectDeployment = this.permissionService.getPermission('ApproveDeployment') || this.permissionService.getPermission('RejectDeployment');
    this.isApproveRejectCertification = this.permissionService.getPermission("ApproveCertification") || this.permissionService.getPermission("RejectCertification");
    this.questions=[{question: this.sharedEnum.starter_faq_question1, answer:this.sharedEnum.starter_faq_answer1},
    {question:this.sharedEnum.starter_faq_question2, answer:this.sharedEnum.starter_faq_answer2},
    {question:this.sharedEnum.starter_faq_question3, answer:this.sharedEnum.starter_faq_answer3},
    {question:this.sharedEnum.starter_faq_question4, answer:this.sharedEnum.starter_faq_answer4, link:"https://developer-help.icertis.com/docs/raising-tickets-in-servicenow/"},
    {question:this.sharedEnum.starter_faq_question5, answer:this.sharedEnum.starter_faq_answer5, link:"https://developer-help.icertis.com/docs/raising-tickets-in-servicenow/#deploy-to-production"},
  ]
    this.titleService.setTitle('Home | ALM Studio');
    this.permissionService.GetIDNConfiguration().subscribe(resp =>{
      this.resources[0].link = resp.body.content.idnHelpURL;
    });
    this.partnerAccess = this.permissionService.hasGlobalDataAccess();
    this.isDeveloper = this.permissionService.getUsercategoryId() != 1 && !this.permissionService.getPermission('InitiateDeployment') && !this.permissionService.getPermission('CreateUser');
    this.isTechLead = this.permissionService.getUsercategoryId() != 1 && this.permissionService.getPermission('InitiateDeployment') && !this.permissionService.getPermission('CreateUser');
    this.isAdmin = this.permissionService.getUsercategoryId() != 1 && this.permissionService.getPermission('InitiateDeployment') && this.permissionService.getPermission('CreateUser');
    this.isViewInstance = this.permissionService.getPermission('ViewInstance');
    this.isViewExtension = this.permissionService.getPermission('ViewExtension');
    this.isPartnerAdmin = (!this.partnerAccess && this.isViewInstance && this.isViewExtension);
    this.isPartnerDeveloper = (!this.partnerAccess && this.isViewInstance && (this.isViewExtension == false));
    this.getInsightData();
    this.links = this.getLinksCards();
    this.instightsCards = [
      {id: "mytsk",title: "My Tasks", count:0, icon:"fact_check", imgsrc:'../../../assets/images/myTasks.png', navLink:'home/actionables/my-approvals', hasPermission: (this.approvalAccessToDebuggingUtilitiesProd || this.approvalAccessHangfire || this.isApproveRejectInstance || this.isApproveRejectDeployment || this.isApproveRejectCertification)},
      {id: "cust", title: "Customers",count: 0, icon:"groups", imgsrc:'../../../assets/images/customers.svg', navLink:'home/administration/customer-management', hasPermission: this.permissionService.getPermission('ViewCustomer')},
      {id: "usr",title: "Users", count: 0 ,icon:"people", imgsrc:'../../../assets/images/users.svg', navLink:'home/administration/user-management', hasPermission: this.permissionService.getPermission('ViewUser')},
      {id: "inst",title: "Instances", count: 0 ,icon:"account_tree", imgsrc:'../../../assets/images/instance.png', navLink:'home/instanceoperations/instance-requests', hasPermission: this.permissionService.getPermission('ViewInstance')},
      {id: "pkg",title: "Extensions", count: 0 ,icon:"pix", imgsrc:'../../../assets/images/custom-packages.png', navLink:'home/developmentandutilities/extension-management', hasPermission: this.permissionService.getPermission('ViewExtension')},
      {id: "dep",title: "Deployments", count: 0 ,icon:"install_desktop", imgsrc:'../../../assets/images/deployment.png', navLink:'home/instanceoperations/deployment', hasPermission: this.permissionService.getPermission('ViewDeployment')},
      {id: "cert",title: "Certifications", count: 0 ,icon:"workspace_premium", imgsrc:'../../../assets/images/certify.png', navLink:'home/developmentandutilities/certification-request', hasPermission: this.permissionService.getPermission('ViewCertification')}
      ];
      this.quickLinksCards.forEach(element => {
        if(element.hasPermission){
          this.isQuickActions = true;
        }
      });
  }

  getLinksCards(){
    return [
      {name:"Quick Setup", description: "Set up Configuration Studio on your local machine", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/setting-up-idn-workbench/', hasPermission: this.isDeveloper },
      {name:"Get Started", description: "Start developing solutions", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/preparing-for-developing-solutions/', hasPermission: this.isDeveloper },
      {name:"Onboard", description: "Set up your team", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/managing-customers-and-instances/', hasPermission: this.isAdmin || this.partnerAccess},
      {name:"Develop", description: "Develop and Build Solutions", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/developing-and-building-solutions/', hasPermission: this.isDeveloper },
      {name:"Guidelines", description: "Access coding guidelines and best practices", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/ici-coding-guidelines-3/', hasPermission: this.isDeveloper },
      {name:"Solution Examples", description: "Access development guides and examples", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/customizing-a-ui-field/', hasPermission: this.isDeveloper || this.isTechLead },
      {name:"ICI Hooks", description: "Learn about ICI hooks", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/overview-of-hooks-2/',  hasPermission: this.isDeveloper },
      {name:"List of Hooks", description: "View all available hooks", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/list-of-hooks-in-ici/',  hasPermission: this.isDeveloper || this.isTechLead },
      {name:"ICI Tasks", description: "Learn about ICI tasks", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/ici-task-overview/',  hasPermission: this.isDeveloper },
      {name:"APIs", description: "Learn about APIs", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/icertis-apis/',  hasPermission: this.isDeveloper },
      {name:"FAQs", description: "Find answers to common questions ", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/faqs-3/',  hasPermission: this.isDeveloper },
      {name:"Troubleshoot", description: "Resolve issues with debugging tools", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/idn-debugging-tools/', hasPermission: true },
      {name:"Provision ICI Users", description: "Assign access to ICI instances", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/managing-customers-and-instances/#add-ici-instance-users', hasPermission: this.isAdmin || this.isTechLead || this.partnerAccess },
      {name:"Manage & Deploy", description: "Manage and deploy your solutions", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/managing-extensions-and-deploying-packages/', hasPermission: this.isAdmin || this.isTechLead || this.partnerAccess },
      {name:"Certify", description: "Get your solutions certified", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/managing-certifications-and-releasing-packages/', hasPermission: this.isAdmin || this.isTechLead || this.partnerAccess },
      {name:"Deploy to Production", description: "Move solutions to the production environment", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/raising-tickets-in-servicenow/#deploy-to-production', hasPermission: this.isAdmin || this.isTechLead || this.partnerAccess },
      {name:"Support", description: "Create a support ticket or report issues", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/raising-tickets-in-servicenow/', hasPermission: this.isAdmin || this.isTechLead || this.partnerAccess },
      {name:"FAQs", description: "Find answers to common questions ", icon : "help_outline", link: 'https://developer-help.icertis.com/docs/partner-admin-faq/', hasPermission: this.isAdmin || this.isTechLead || this.partnerAccess},  
    ]
  }

  breadCrumbItems: any = [
    { label: "Home", path: "resources"},
    { label: "Resources", path: "resources"}
  ];

  startGame() {
    if( this.progress <= 99){
      this.progress = this.progress + 1;
    }
    console.log (this.progress);
  }

  opensnack(progress: string) : void {
    console.log(progress);
  }

  getInsightData(){
    try{
      this.instanceService.getIdnInsights().subscribe((data:any) => {
        let result = data?.body;
        if(result){
          this.loggerInUserRole = result?.roleName;
          localStorage.setItem('userRoleName', this.loggerInUserRole);
          this.instanceService.sendRoleNameData(this.loggerInUserRole);
          this.instightsCards[0].count = result?.totalToolsFeatureAccessRequestsCount;
          this.instightsCards[1].count = result?.totalCustomers;
          this.instightsCards[2].count = result?.totalUsers;
          this.instightsCards[3].count = result?.totalInstances;
          this.instightsCards[4].count = result?.totalPackages;
          this.instightsCards[5].count = result?.totalDeployments;
          this.instightsCards[6].count = result?.totalCertifications;
           
        }
      })
    } catch(error){
      console.log(error)
    }
  }

  resources: any = [
    { id: "1", heading: "IDN Help", image: "../../../assets/images/resources/tech_connect.jpg", link:'', description: "Get access to a library of Icertis learning material to help you get started"},
  ];

  redirectLink(navLink: any): void {

    this.dialogService.confirmDialog({
      title: this.logoutEnum.redirect_dialog_heading,
      module: 'resources',
      message: this.logoutEnum.redirect_dialog_body,
      confirmText: this.logoutEnum.redirect_dialog_primary_btn,
      cancelText: this.logoutEnum.redirect_dialog_secondary_btn
    }).subscribe((res: any) => {
      if(res){
        window.open(navLink, "_blank");
      }
    })
  }

  openSite(siteUrl:any) {
    this.dialogService.confirmDialog({
      title: this.logoutEnum.redirect_dialog_heading,
      module: 'resources',
      message: this.logoutEnum.redirect_dialog_body,
      confirmText: this.logoutEnum.redirect_dialog_primary_btn,
      cancelText: this.logoutEnum.redirect_dialog_secondary_btn
    }).subscribe((res: any) => {
      if(res){
        window.open(siteUrl, '_blank');
      }
    });
 }

 onWhatsNew() {
  this.idnConfiguration.emitWhatsNewFeature(true);
  }

  downloadFile(){
    let link = document.createElement("a");
    link.download = "Quick Start Quide";
    link.href = "assets/docs/Icertis Developer Network - Quick Start Guide - V1.0 2.pdf";
    link.click();
  }

  gotoTop(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  isElementVisible(element: HTMLElement) {
    var rect = element.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return (
      rect?.top >= 0 &&
      rect?.bottom <= windowHeight
    );
  }

  ngAfterViewChecked(){
    let element = document?.getElementById('top-section')
    if(element){
      this.isShow = !this.isElementVisible(element);
    }
  }

  navigateToModule(navLink:any){
    console.log(navLink)
    if(navLink){
      this.router.navigate([navLink]);
    }
  }

  navigateQuickLinkItems(card:any){
    try{
      let getInputFor =['4', '6', '7', '8'];
      if(getInputFor?.includes(card?.id)){
        this.instanceService.getInstanceExtensionsDetails().subscribe((data:any)=>{
          if(data?.body){
            let provisionUserInstanceList = data?.body?.instanceRequestInfoList?.filter((item:any)=> !item.isInstancePointingToCustomerAD && item.instanceType != 'Production');
            let inputData = card?.id == 4? data.body?.extensionInfoList : card?.id == 8? provisionUserInstanceList : data.body?.instanceRequestInfoList
            this.dialogService.confirmDialog({
              title: card.title,
              module: 'quick-actions',
              message: JSON.stringify(inputData),
              confirmText: 'Confirm',
              cancelText: 'Cancel'
            }).subscribe((res: any) => {
              let navLink ='';
              if(res && res != undefined){
                if(card.id == 4){
                  card['fromQuickActions'] = true;
                  card['id'] = res;
                  this.extensionservice.emitExtDetails(card);
                  navLink ='home/developmentandutilities/extension-management/view';
                } else if(card.id == 6){
                  localStorage.setItem('instanceID', res);
                  navLink = 'home/instanceoperations/instance-requests/initiate-deployment';
                } else if(card.id == 7){
                  localStorage.setItem('instanceID', res);
                   navLink = 'home/instanceoperations/instance-requests/instance-tools-landing';
                } else if(card.id == 8){
                  localStorage.setItem('instanceID', res);
                   navLink = 'home/instanceoperations/instance-requests/provision-users';
                }
                this.router.navigate([navLink]);
              }
            })
          }
        })
      } else if(card.id == 5){
        let navLink = 'home/developmentandutilities/certification-request';
        this.router.navigate([navLink]);
      } else if(card.id == 3){
        let navLink = 'home/administration/customer-management/create';
        this.router.navigate([navLink]);
      } else if(card.id == 2){
        let navLink = 'home/administration/user-management/create';
        this.router.navigate([navLink]);
      } else if(card.id == 1){
        //starter kit
        this.downloadFile();
      } else if(card.id == 0){
        //wokerbench
        this.downloadWorkbench()
      }
    } catch(error){
      console.log(error)
    }
   
  }

 downloadWorkbench() {
    try {
      this.loader.show();
      var FileSaver = require('file-saver');
      this.SdkServices.downloadLatestWorkbench().subscribe(async (resp: any) => {
        if (resp != null && resp != undefined) {
         let fileSize = resp?.blobSize / (1024 * 1024);  //convert byte to MB          

          if(fileSize >= 5){
            this.notificationService.showNotification(
              this.WbMgmtEnum.wb_notify_download_start_body,
              'success',
              this.WbMgmtEnum.wb_notify_download_start_heading
            );
          }
         
          setTimeout(() => {
            this.loader.hide();             
          }, 2000);
          
          this.blobService.downloadImageExt(
            resp?.sasUrl,
            resp?.container,
            resp?.blob,
            (response: any) => {
              if (
                response._response != undefined &&
                response._response.status == '200'
              ) {
                response.blobBody.then((onres: any) => {
                  this.SdkServices.markDownloaded(resp.workbenchId)
                    .pipe(
                      map((data: any) => {
                        this.notificationService.showNotification(
                          this.WbMgmtEnum.wb_notify_mark_download_body,
                          'success',
                          this.WbMgmtEnum.wb_notify_mark_download_heading
                        );
                        this.activityNotifService.TriggerSDKNotification(
                          resp.workbenchId,
                          false
                        );
                      }),
                      catchError((err) => {
                        this.notificationService.showNotification(
                          this.WbMgmtEnum.wb_notify_not_mark_download_body,
                          'error',
                          this.WbMgmtEnum.wb_notify_not_mark_download_heading
                        );

                        console.log(err);

                        return err;
                      })
                    )
                    .subscribe();
                  const fileName = resp.blob.split('/');
                  if(fileName.length > 0) {
                  FileSaver.saveAs(onres, fileName[1]);
                  }
                });
              } else {
                this.notificationService.showNotification(
                  this.WbMgmtEnum.wb_notify_download_failed_body,
                  'error',
                  this.WbMgmtEnum.wb_notify_download_failed_heading
                );
              }
            }
          );
        }
      });
    } catch (err) {
      console.log(err);
    }
  }
  

}
